import axios from 'axios'

export default {
    async create(model) {
        return await axios.post(`payment-purpose`, model)
    },
    async fetchById(id) {
        return await axios.get(`payment-purpose/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`payment-purpose?q=${query}&page=${page}`)
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`payment-purpose/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`payment-purpose/${id}`)
    },
}
